export const TOP_BANNER_TYPES = {
  DEFAULT: "default",
  PREMIUM: "premium",
  PLUS: "plus",
};
